<template>
  <div style="height: 100%">
    <el-form :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item>
        <el-input v-model="filters.jobNumber" placeholder="工号" style="min-width: 240px;"
                  @keyup.enter.native="handleSearch" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="filters.nickName" placeholder="姓名" style="min-width: 240px;"
                  @keyup.enter.native="handleSearch" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
      </el-form-item>
    </el-form>

    <el-col :span="24"  v-loading="loading"  element-loading-text="拼命加载中" style="height: 355px">
      <!--列表-->
      <el-table ref="multipleTable" :data="list" height="356" @selection-change="selectionChange" :row-key="getRowKeys" >
        <el-table-column type="selection" :reserve-selection="true" min-width="7"></el-table-column>
        <el-table-column prop="nickName" label="姓名" min-width="50" >
        </el-table-column>
        <el-table-column prop="jobNumber" label="工号" min-width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" min-width="80"></el-table-column>
        <el-table-column prop="cartid" label="身份证号码" min-width="200"></el-table-column>
      </el-table>
    </el-col>
    <div>
      <el-pagination
        style="float:right;"
        layout="prev, pager, next"
        background @current-change="handleCurrentChange"
        :page-size="limit"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import API from '@/api/api_employee';

export default {
  components: {

  },
  data() {
    return {
      filters: {
        jobNumber: undefined,
        nickName: undefined
      },
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      loading: false,

      selectDataList: [],
      isSelectionIn: false,

      enterpriseId: undefined
    };
  },
  methods: {
    selectionChange(e) {
      this.selectDataList = [];
      if (e) {
        e.forEach(obj => {
          let label = undefined;
          if (obj.nickName) {
            label = '「用户」' + obj.nickName;
          } else {
            label = obj.label;
          }

          this.selectDataList.push({
            key: obj.userId,
            label: label,
            personType: "0"
          })
        })
      }
      if (!this.isSelectionIn) {
        this.$emit("selection-change", this.selectDataList);
      }
    },
    getRowKeys(row) {
      if (row.userId) {
        return row.userId;
      } else {
        return row.key;
      }
    },
    //点击查询所调用的函数
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //查询列表函数
    search: function () {
      let that = this;
      let params = Object.assign({
        page: that.page,
        limit: 10,
        enterpriseId: this.enterpriseId
      }, that.filters);

      that.loading = true;
      API.findList(params).then(
        function (result) {
          that.loading = false;
          if (result && result.page.rows) {
            that.total = result.page.total;
            that.list = result.page.rows;
          }
        },
        function (err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      ).catch(function (error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    setSelection(rows) {
      this.isSelectionIn  = true;
      if (this.selectDataList){
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection({
            key: row.key,
            userId: row.key,
            label: row.label,
            nickName: row.label
        });
        });
        this.tableReload();
      }
      this.isSelectionIn = false;
    },
    tableReload() {
      this.list = JSON.parse(JSON.stringify(this.list));
    },
  },
  mounted() {
    this.handleSearch();
    let userInfo = JSON.parse(localStorage.getItem('userinfo'));
    this.enterpriseId = userInfo.enterpriseId;
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/component/user/empSelection.vue